export default function slideProduct() {
  document.querySelectorAll('.js-productSlider').forEach((element) => {
    // eslint-disable-next-line no-new
    new Swiper(element, {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 200,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      },
    });
  });
}
